import InsightResults from "./ai-insight-result";
import DeepScanResult from "./deep-scan-result";
import HeroScanSection from "./hero-scan-section";
import ReportPhishing from "./report-phishing";
import OverviewTab from "./overview/OverviewTab";
import HistoryView from "./history-result/HistoryView";

export const tabRoutes = [
    {
        key: "hero-scan-section",
        title: "Hero Scan Section",
        component: HeroScanSection,
    },
    {
        key: "ai-insight-result",
        title: "AI Insight Result",
        component: InsightResults
    },
    {
        key: "deep-scan-result",
        title: "Deep Scan Result",
        component: DeepScanResult,
    },
    {
        key: "report-phishing",
        title: "Report Phishing",
        component: ReportPhishing
    },
    {
        key: "overview",
        title: "Overview",
        component: OverviewTab
    },
    {
        key: "history-result",
        title: "History Result",
        component: HistoryView
    }
] as const;

export type TabKey = typeof tabRoutes[number]['key'];


export interface TabRoute {
    key: TabKey;
    title: string;
    component: React.ComponentType;
}